import BCC from "./components/bcc/bcc";
import { createContext } from "react";
const AppContext = createContext({} as any);
export default AppContext;
export type I_CTX = {bcc:BCC}